<template>
  <div class="d-sm-flex justify-content-sm-between align-items-center">
    <b-button-group size="sm" class="text-right">
      <b-iconstack variant="dark" v-b-tooltip.hover :title="$gettext('Select PDF')" @click="$emit('toggle')">
        <b-icon icon="square" stacked />
        <b-icon icon="check" v-if="selected" scale="0.7" stacked />
      </b-iconstack>
      <b-icon icon="info-square" variant="primary" class="mx-1" v-b-tooltip.hover :title="$gettext('View more')"
        @click="$emit('info')" />
    </b-button-group>
    <h4 class="mb-0 font-weight-bolder">{{ result.name }}</h4>
    <div class="tour-price font-weight-bolder text-right">
      <small>de la</small>
      {{ minPrice.toFixed(2) }} {{ result.currency }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    minPrice () {
      let minPrice = 0
      for (const key in this.result.dates) {
        const price = this.result.dates[key].price.gross + this.result.dates[key].price.tax
        if (minPrice === 0) minPrice = price
        if (price < minPrice) minPrice = price
      }
      return minPrice
    }
  }
}
</script>
